import { App } from './App';

App.Util = {};
